import * as Yup from "yup";
import R from "ramda";

export const initialValues = (makeMessage = null) => {
  return {
    sender: R.propOr("", "sender", makeMessage),
    recipient: R.propOr("", "recipient", makeMessage),
    message: R.propOr("", "message", makeMessage),
  };
};

export const validationSchema = Yup.object().shape({
  sender: Yup.string()
    .trim()
    .max(50, "From can not be more than 50 symbols"),
  recipient: Yup.string()
    .trim()
    .max(50, "To can not be more than 50 symbols"),
  message: Yup.string()
    .trim()
    .max(600, "Message can not be more than 600 symbols"),
});

export const attributesToSubmit = (values, make) => {
  const { sender, recipient, message } = values;
  const { id } = make;

  return {
    data: {
      attributes: {
        message,
        recipient,
        sender,
      },
      relationships: {
        make: {
          data: {
            type: "makes",
            id,
          },
        },
      },
      type: "make-messages",
    },
  };
};
